import { version } from '../../data/version';
import { landingStyles } from '../landing.styles';

export const LandingFooter = () => {
	return (
		<footer style={landingStyles.footer}>
			<p>© 2025 Kaiteki - Telemedicina</p>
			<div style={{ display: 'flex', justifyContent: 'center', gap: '30px'}}>
				<a href="/legals/terms-and-conditions">Términos y Condiciones</a>
				<a href="/legals/privacy-policy">Política de Privacidad</a>
				<a href="https://overload-consulting.com" target="_blank">Developed by Overload Consulting</a>
				<span title={`Version ${version}`}>Version {version}</span>
			</div>
		</footer>
	);
};
